import React from 'react'
import ReactDOM from 'react-dom'
import { AccessCodeManagementApp } from './components/App'

export let startAccessCodeManagement = (coursenum, resultsPerPage) => {
  ReactDOM.render(
    <AccessCodeManagementApp
      coursenum={coursenum}
      resultsPerPage={resultsPerPage}
    />,
    document.getElementById('accessCodeManagementApp')
  )
}
